import { getIntroAction } from 'automaton/actions/AwaitIntroAction'
import { getBuildGameAction } from 'automaton/actions/BuildGameAction'
import { getBuildSplashAction } from 'automaton/actions/BuildSplashAction'
import { getBuildStageAction } from 'automaton/actions/BuildStageAction'
import { getDelayAction } from 'automaton/actions/DelayAction'
import { getFontsAction } from 'automaton/actions/FontsAction'
import { getLoadAction } from 'automaton/actions/LoadAction'
import { getParticleLoadAction } from 'automaton/actions/LoadParticleAction'
import { getLoadSplashAction } from 'automaton/actions/LoadSplashAction'
import { getLocalizationAction } from 'automaton/actions/LocalizationAction'
import { getLogoShowAction } from 'automaton/actions/LogoShowAction'
import { getPreLoadAction } from 'automaton/actions/PreLoadAction'
import { getPreSetupAction } from 'automaton/actions/PreSetupAction'
import { getRequestInitAction } from 'automaton/actions/RequestInitAction'
import { getSetupAction } from 'automaton/actions/SetupAction'
import { getBetState } from 'automaton/states/BetState'
import { getFreebetAddState } from 'automaton/states/FreebetAddState'
import { getFreeBetState } from 'automaton/states/FreeBetState'
import { getFreespinAddState } from 'automaton/states/FreespinsAddState'
import { getFreespinEndState } from 'automaton/states/FreespinsEndState'
import { getFreespinsRespinState } from 'automaton/states/FreespinsRespinState'
import { getFreespinsSpinState } from 'automaton/states/FreespinsSpinState'
import { getRespinState } from 'automaton/states/RespinState'

export function getInitState() {
  const freespinModel = game.models.FreespinModel.get()
  const spinModel = game.models.SpinModel.get()
  const freebetModel = game.models.FreebetsModel.get()

  const name = 'INIT'
  const actions = [
    getFontsAction(),
    getPreLoadAction(),
    getLocalizationAction(),
    getBuildStageAction(),
    getPreSetupAction(),
    getLoadSplashAction(),
    getLogoShowAction(),
    getBuildSplashAction(),
    getParticleLoadAction(),
    getLoadAction(),
    getRequestInitAction(),
    getBuildGameAction(),
    getDelayAction(2),
    getSetupAction(),
    getIntroAction(),
  ]

  const transition = () =>  spinModel.respin.length ? freespinModel.all ? getFreespinsRespinState() : getRespinState() : freespinModel.all ? freespinModel.left ? freespinModel.left === freespinModel.all ? getFreespinAddState(false) : freespinModel.add ? getFreespinAddState(true) : getFreespinsSpinState() : getFreespinEndState() :
    freebetModel.add ? getFreebetAddState() : freebetModel.rest ? getFreeBetState() : getBetState()
  return {
    name,
    actions,
    transition,
  }
}
